import { Pipe, PipeTransform, Injector } from '@angular/core';

@Pipe({
    name: 'prop',
    standalone: false
})
export class PropertyPipe implements PipeTransform {

  public constructor(private injector: Injector) {
  }

  transform(obj: any, propertyName:string): any {

    if (obj == null)
      return null;

    return obj[propertyName];

  }
}
